var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15537 3.05859C9.15414 3.05859 10.1305 3.35477 10.9609 3.90966C11.7914 4.46455 12.4387 5.25323 12.8209 6.17598C13.2031 7.09873 13.3031 8.1141 13.1082 9.09368C12.9134 10.0733 12.4324 10.9731 11.7262 11.6793C11.0199 12.3856 10.1201 12.8665 9.14056 13.0614C8.16097 13.2562 7.1456 13.1562 6.22286 12.774C5.30011 12.3918 4.51142 11.7445 3.95653 10.9141C3.40164 10.0836 3.10547 9.10727 3.10547 8.10849C3.10547 7.44533 3.23609 6.78866 3.48987 6.17598C3.74365 5.5633 4.11562 5.0066 4.58455 4.53768C5.53159 3.59064 6.81605 3.05859 8.15537 3.05859Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6963 11.707L14.885 14.9425",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.eae112d18656abc2bc348d4c6751b6bf.svg";
export { ForwardRef as ReactComponent };